import { GENERATE_REPORT, GENERATE_REPORT_FAILURE, GENERATE_REPORT_SUCCESS } from '../constants'


const initialState = {
    reportsData: {},
    loader: false,
    // detailLoader: false,
    // assignLoader: false
}

export default function ReportReducer(state = initialState, action) {
    switch (action.type) {
        case GENERATE_REPORT:
            state = {
                ...state,
                loader: true,
                reportsData: {}
            }
            break;

        case GENERATE_REPORT_SUCCESS:
            state = {
                ...state,
                reportsData: action.payload,
                loader: false
            }
            break

        case GENERATE_REPORT_FAILURE:
            state = {
                ...state,
                loader: false,
                reportsData: {}
            }
            break

        default:
            break;
    }

    return state
}